
export class ForbiddenError extends Error {
    constructor(message: string) {
        super('HTTP 403 Error:' + message);
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, ForbiddenError.prototype);
    }
}
